import { render, staticRenderFns } from "./SearchProductPage.vue?vue&type=template&id=66ec3825&scoped=true"
import script from "./SearchProductPage.vue?vue&type=script&lang=ts"
export * from "./SearchProductPage.vue?vue&type=script&lang=ts"
import style0 from "./SearchProductPage.vue?vue&type=style&index=0&id=66ec3825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec3825",
  null
  
)

export default component.exports